import { Outlet } from "react-router-dom";
import { PartnerAuthProvider } from "../../auth/PartnerAuthProvider";

/** Shared partner auth context for login and portal routes. */
export default function PartnerAuthGate() {
  return (
    <PartnerAuthProvider>
      <Outlet />
    </PartnerAuthProvider>
  );
}
